import React, { useState, useEffect } from "react";

export default function GetStarted() {
  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();

    useEffect(() => {
      (async () => {
        // if (window.dataLayer) {
        //   await window.dataLayer.push({ event: "optimize.activate" });
        // }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    }, []);
    return variant;
  };

  const variant = useExperiment("yWZT-4xlS9-M9AZuPD95Xg");
  return (
    <div className=" bg-darkBlue py-28">
      <div className="mainContainer w-full lg:px-0 px-2 lg:w-7/12 flex justify-center mx-auto flex-col text-center">
        <h2 className="text-white text-4xl font-semibold">
          <span className="text-orange">Ready</span> to Get Started?
        </h2>
        <p className="text-white py-8">
          If you're a new client looking to broaden your horizons with Tomedes, here's your chance to partner with us. Contact us today, or
          get a free quote right now.
        </p>
        <div className="flex lg:flex-row flex-col lg:gap-y-0 gap-y-8 text-white mx-auto py-4 gap-x-8  ">
          <a
            href="/quote"
            className="rounded-full text-xs font-semibold px-5 py-3 flex justify-center items-center bg-orange hover:bg-[#ff9a16]"
          >
            {variant == "1" ? "ORDER NOW" : "TRANSLATE NOW"}
          </a>
          <a
            href="/contactus.php"
            className="rounded-full px-7 py-3 border text-xs font-semibold flex justify-center items-center border-white hover:bg-white hover:text-black"
          >
            CONTACT US
          </a>
        </div>
      </div>
    </div>
  );
}
